import { useAccount, useLogout, useStopImpersonating } from "@qw/auth";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Icon,
} from "@qw/ui";
import { useState } from "react";
import { Shiny } from "@/components/shiny";
import { canImpersonate } from "@/utils/impersonation";
import { resetPostHog } from "../posthog";
import { ImpersonationMenu } from "./impersonation-menu";
import { InboxSettingsDialog } from "./inbox-settings-dialog";
import { resetInboxLayout } from "./reset-inbox-layout";

export const UserMenu = () => {
  const authLogout = useLogout();
  const [stopImpersonating] = useStopImpersonating();
  const { user, impersonatorEmail } = useAccount();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const logout = () => {
    resetPostHog();
    authLogout();
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Shiny>{user.firstName[0]}</Shiny>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuLabel className="items-start">
            <Icon icon="account_circle" className="mt-0.5" />
            <div className="space-y-1">
              <div>
                {user.firstName} {user.lastName}
              </div>
              <div className="font-normal text-2xs text-muted-foreground">{user.agency.name}</div>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => setSettingsOpen(true)}>
            <Icon icon="settings" />
            Settings
          </DropdownMenuItem>
          <DropdownMenuItem onClick={resetInboxLayout}>
            <Icon icon="reset_wrench" />
            Reset layout
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          {impersonatorEmail ? (
            <DropdownMenuItem onClick={() => stopImpersonating()}>
              <Icon icon="logout" />
              Stop Impersonating
            </DropdownMenuItem>
          ) : canImpersonate(user) ? (
            <ImpersonationMenu />
          ) : null}
          <DropdownMenuItem onClick={logout}>
            <Icon icon="login" />
            Sign Out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <InboxSettingsDialog open={settingsOpen} onOpenChange={setSettingsOpen} />
    </>
  );
};
